import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import axios from "axios";

export async function getOutputFile() {
  try {
    const { data } = await axios.get(`${URL_API}/output-file`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return { success: true, message: "", data: data.data, code: 200 };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function createOutputFile(payload) {
  try {
    const { data } = await axios.post(`${URL_API}/output-file`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      data: data.data,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: null,
      errors: error.response.data.errors,
    };
  }
}

export async function updateOutputFile({ id, payload }) {
  try {
    const { data } = await axios.put(`${URL_API}/output-file/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      data: null,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
      errors: error.response.data.errors,
    };
  }
}

export async function deleteOutputFile(id) {
  try {
    await axios.delete(`${URL_API}/output-file/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: "",
      data: null,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      data: null,
      message: error.response.statusText,
    };
  }
}
